import { balanceText } from 'balanced-text'

export default {
    methods: {
        useBalanceText(element) {
            return balanceText({
                elements: element,
                watch: true,
                debounce: 0,
                lazyBalance: true,
                disableWait: false
            })
        }
    }
}
